import type { ReactElement } from "react";

/**
 * Line glyphs that mirror the server-rendered icon set in src/public/render.ts, so the
 * React graphs share the exact visual language as the rest of the site.
 */
export const GLYPHS: Record<string, ReactElement> = {
  code: <path d="m9 8-5 4 5 4m6-8 5 4-5 4m-2-11-2 14" />,
  cloud: <path d="M7 18a4 4 0 0 1 0-8 6 6 0 0 1 11.5-1.7A4 4 0 0 1 18 18H7Z" />,
  shield: (
    <>
      <path d="m12 3 7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6l7-3Z" />
      <path d="m9 12 2 2 4-4" />
    </>
  ),
  ai: (
    <path d="M9 4.5A3 3 0 0 1 12 7a3 3 0 0 1 3-2.5A3 3 0 0 1 18 8v1a3 3 0 0 1 0 6v1a3 3 0 0 1-3 3 3 3 0 0 1-3-2.5A3 3 0 0 1 9 19a3 3 0 0 1-3-3v-1a3 3 0 0 1 0-6V8a3 3 0 0 1 3-3.5Z" />
  ),
  globe: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18M12 3c2.5 2.5 4 5.5 4 9s-1.5 6.5-4 9c-2.5-2.5-4-5.5-4-9s1.5-6.5 4-9Z" />
    </>
  ),
  chart: <path d="M4 19V5m0 14h16M8 15l3-4 3 2 5-7" />,
  search: (
    <>
      <circle cx="11" cy="11" r="7" />
      <path d="m20 20-3.5-3.5" />
    </>
  ),
  layers: (
    <>
      <path d="m12 3 9 5-9 5-9-5 9-5Z" />
      <path d="m3 13 9 5 9-5M3 17l9 5 9-5" />
    </>
  ),
};

/** Render a glyph centred inside a 24×24 box, scaled/translated to the given size. */
export function Glyph({
  name,
  size = 24,
  x = 0,
  y = 0,
  strokeWidth = 1.8,
}: {
  name: string;
  size?: number;
  x?: number;
  y?: number;
  strokeWidth?: number;
}): ReactElement {
  const scale = size / 24;
  return (
    <g
      transform={`translate(${x - size / 2} ${y - size / 2}) scale(${scale})`}
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth / scale}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {GLYPHS[name] ?? GLYPHS.code}
    </g>
  );
}
